{
  "Done": "Done",
  "Feedback": "Feedback",
  "How would you rate the new experience?": "How would you rate the new experience?",
  "Please share as much detail on issues you are experiencing or suggestions for how we can improve the\n              experience.": "Please share as much detail on issues you are experiencing or suggestions for how we can improve the\n              experience.",
  "Please type here...": "Please type here...",
  "Submit": "Submit",
  "Thank you for your feedback!": "Thank you for your feedback!",
  "Your response has been recorded": "Your response has been recorded"
}
